import { confirmAsync } from '../../utils/confirm';
import { useState, useEffect } from 'react';
import DatePicker from '../../components/DatePicker';

// ── Sabit veriler ──
const GRUP_TIP_LISTESI = ['Farketmez', 'KAMU', 'SİVİL', 'AYLIK', 'YILLIK'];
const SEHIRLER = ['Adana', 'Adıyaman', 'Afyonkarahisar', 'Ağrı', 'Aksaray', 'Amasya', 'Ankara', 'Antalya', 'Ardahan', 'Artvin', 'Aydın', 'Balıkesir', 'Bartın', 'Batman', 'Bayburt', 'Bilecik', 'Bingöl', 'Bitlis', 'Bolu', 'Burdur', 'Bursa', 'Çanakkale', 'Çankırı', 'Çorum', 'Denizli', 'Diyarbakır', 'Düzce', 'Edirne', 'Elazığ', 'Erzincan', 'Erzurum', 'Eskişehir', 'Gaziantep', 'Giresun', 'Gümüşhane', 'Hakkari', 'Hatay', 'Iğdır', 'Isparta', 'İstanbul', 'İzmir', 'Kahramanmaraş', 'Karabük', 'Karaman', 'Kars', 'Kastamonu', 'Kayseri', 'Kırıkkale', 'Kırklareli', 'Kırşehir', 'Kilis', 'Kocaeli', 'Konya', 'Kütahya', 'Malatya', 'Manisa', 'Mardin', 'Mersin', 'Muğla', 'Muş', 'Nevşehir', 'Niğde', 'Ordu', 'Osmaniye', 'Rize', 'Sakarya', 'Samsun', 'Şanlıurfa', 'Siirt', 'Sinop', 'Şırnak', 'Sivas', 'Tekirdağ', 'Tokat', 'Trabzon', 'Tunceli', 'Uşak', 'Van', 'Yalova', 'Yozgat', 'Zonguldak'];
const ILCELER = { 'Adana': ['Aladağ', 'Ceyhan', 'Çukurova', 'Feke', 'İmamoğlu', 'Karaisalı', 'Karataş', 'Kozan', 'Pozantı', 'Saimbeyli', 'Sarıçam', 'Seyhan', 'Tufanbeyli', 'Yumurtalık', 'Yüreğir'], 'Ankara': ['Altındağ', 'Ayaş', 'Bala', 'Beypazarı', 'Çamlıdere', 'Çankaya', 'Çubuk', 'Elmadağ', 'Etimesgut', 'Evren', 'Gölbaşı', 'Güdül', 'Haymana', 'Kalecik', 'Kazan', 'Keçiören', 'Kızılcahamam', 'Mamak', 'Nallıhan', 'Polatlı', 'Pursaklar', 'Sincan', 'Şereflikoçhisar', 'Yenimahalle'], 'Antalya': ['Akseki', 'Aksu', 'Alanya', 'Demre', 'Döşemealtı', 'Elmalı', 'Finike', 'Gazipaşa', 'Gündoğmuş', 'İbradı', 'Kaş', 'Kemer', 'Kepez', 'Konyaaltı', 'Korkuteli', 'Kumluca', 'Manavgat', 'Muratpaşa', 'Serik'] };

// ── Mock misafir verisi (rezervasyonlardan gelecek) ──
const mockMisafirler = [
  { id:1, adSoyad:'kadrikara',    telefon:'',            cinsiyet:'Erkek', grup:'Yok',   karaListesi:'Hayır', ulke:'TÜRKİYE', sehir:'Adana',    ilce:'Aladağ',   tcKimlik:'',            email:'',                dogumYeri:'',        dogumTarihi:'08.03.2026', yabanciAd:'', yabanciSoyad:'', anaAdi:'',     babaAdi:'',      adres:'',               girisTarihi:'05.03.2026', cikisTarihi:'10.03.2026' },
  { id:2, adSoyad:'Ahmet Yıldız', telefon:'05321234567', cinsiyet:'Erkek', grup:'Yok',   karaListesi:'Hayır', ulke:'TÜRKİYE', sehir:'Antalya',  ilce:'Konyaaltı',tcKimlik:'12345678901', email:'ahmet@test.com',  dogumYeri:'Antalya', dogumTarihi:'15.06.1985', yabanciAd:'', yabanciSoyad:'', anaAdi:'Fatma',babaAdi:'Mehmet',adres:'Konyaaltı Mah.', girisTarihi:'08.03.2026', cikisTarihi:'15.03.2026' },
  { id:3, adSoyad:'Zeynep Arslan',telefon:'05339876543', cinsiyet:'Kadın', grup:'SİVİL', karaListesi:'Hayır', ulke:'TÜRKİYE', sehir:'İstanbul', ilce:'',          tcKimlik:'98765432109', email:'zeynep@test.com', dogumYeri:'İstanbul',dogumTarihi:'22.03.1990', yabanciAd:'', yabanciSoyad:'', anaAdi:'Ayşe', babaAdi:'Ali',   adres:'Kadıköy Mah.',   girisTarihi:'12.03.2026', cikisTarihi:'18.03.2026' },
  { id:4, adSoyad:'Can Öztürk',   telefon:'05441112233', cinsiyet:'Erkek', grup:'KAMU',  karaListesi:'Hayır', ulke:'TÜRKİYE', sehir:'Ankara',   ilce:'Çankaya',  tcKimlik:'11223344556', email:'can@test.com',    dogumYeri:'Ankara',  dogumTarihi:'01.01.1978', yabanciAd:'', yabanciSoyad:'', anaAdi:'Emine',babaAdi:'Hasan', adres:'Çankaya Mah.',   girisTarihi:'01.03.2026', cikisTarihi:'07.03.2026' },
];

// ── Yardımcılar ──
function pad(n) { return String(n).padStart(2,'0'); }
function bugunStr() {
  var d = new Date();
  return pad(d.getDate())+'.'+pad(d.getMonth()+1)+'.'+d.getFullYear();
}
function gelecekHaftaStr() {
  var d = new Date();
  d.setDate(d.getDate() + 7);
  return pad(d.getDate())+'.'+pad(d.getMonth()+1)+'.'+d.getFullYear();
}
function birAyOnceStr() {
  var d = new Date();
  d.setMonth(d.getMonth() - 1);
  return pad(d.getDate())+'.'+pad(d.getMonth()+1)+'.'+d.getFullYear();
}
function ddmmyyyyToDate(s) {
  if (!s) return null;
  var p = s.split('.');
  if (p.length < 3) return null;
  return new Date(Number(p[2]), Number(p[1])-1, Number(p[0]));
}

// ── Misafir Detay Popup ──
function MisafirDetayModal({ misafir, onClose, onKaydet, onSil }) {
  var [form, setForm] = useState({ ...misafir });

  function guncelle(alan, deger) {
    setForm(function(p) { return Object.assign({}, p, { [alan]: deger }); });
  }

  var INPUT = "w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-200";
  var LABEL = "text-xs text-gray-500 font-medium block mb-1";

  var ilceler = form.sehir && ILCELER[form.sehir] ? ILCELER[form.sehir] : [];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-[70] flex items-center justify-center p-4">
      <div className="bg-white w-full max-w-5xl rounded-xl shadow-2xl overflow-hidden max-h-[95vh] flex flex-col">
        {/* Başlık */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
          <h2 className="text-base font-bold text-gray-800">Misafir detayı</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 text-2xl font-bold w-10 h-10 flex items-center justify-center">✕</button>
        </div>

        {/* Form */}
        <div className="flex-1 overflow-y-auto p-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">

            {/* Sol kolon */}
            <div className="space-y-4">
              <div>
                <label className={LABEL}>Ad Soyad</label>
                <input value={form.adSoyad} onChange={function(e){guncelle('adSoyad',e.target.value);}} className={INPUT} />
              </div>
              <div>
                <label className={LABEL}>Ülke</label>
                <input value={form.ulke} onChange={function(e){guncelle('ulke',e.target.value);}} className={INPUT} />
              </div>
              <div>
                <label className={LABEL}>Telefon</label>
                <input value={form.telefon} onChange={function(e){guncelle('telefon',e.target.value);}} className={INPUT} placeholder="05xx xxx xx xx" />
              </div>
              <div>
                <label className={LABEL}>Doğum tarihi</label>
                <DatePicker value={form.dogumTarihi} onChange={function(v){guncelle('dogumTarihi',v);}} />
              </div>
              <div>
                <label className={LABEL}>Cinsiyet</label>
                <div className="flex gap-4 mt-1">
                  {['Erkek','Kadın'].map(function(c){
                    return (
                      <label key={c} className="flex items-center gap-2 cursor-pointer">
                        <input type="radio" checked={form.cinsiyet===c} onChange={function(){guncelle('cinsiyet',c);}} className="accent-blue-600" />
                        <span className="text-sm text-gray-700">{c}</span>
                      </label>
                    );
                  })}
                </div>
              </div>
              <div>
                <label className={LABEL}>Kara listedemi</label>
                <div className="flex gap-4 mt-1">
                  {['Evet','Hayır'].map(function(k){
                    return (
                      <label key={k} className="flex items-center gap-2 cursor-pointer">
                        <input type="radio" checked={form.karaListesi===k} onChange={function(){guncelle('karaListesi',k);}} className="accent-blue-600" />
                        <span className="text-sm text-gray-700">{k}</span>
                      </label>
                    );
                  })}
                </div>
              </div>
              <div>
                <label className={LABEL}>Grup</label>
                <div className="relative">
                  <select value={form.grup||'Yok'} onChange={function(e){guncelle('grup',e.target.value);}}
                    className="w-full border border-gray-300 rounded px-3 py-2 text-sm bg-white appearance-none focus:outline-none">
                    {['Yok'].concat(GRUP_TIP_LISTESI.filter(function(g){return g!=='Farketmez';})).map(function(g){
                      return <option key={g}>{g}</option>;
                    })}
                  </select>
                  <span className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 text-xs">▼</span>
                </div>
              </div>
            </div>

            {/* Orta kolon */}
            <div className="space-y-4">
              <div>
                <label className={LABEL}>T.C Kimlik Pas.</label>
                <input value={form.tcKimlik} onChange={function(e){guncelle('tcKimlik',e.target.value);}} className={INPUT} />
              </div>
              <div>
                <label className={LABEL}>E-mail</label>
                <input value={form.email} onChange={function(e){guncelle('email',e.target.value);}} className={INPUT} />
              </div>
              <div>
                <label className={LABEL}>Doğum Yeri</label>
                <input value={form.dogumYeri} onChange={function(e){guncelle('dogumYeri',e.target.value);}} className={INPUT} />
              </div>
              <div>
                <label className={LABEL}>Yabancı Ad (KBS)</label>
                <input value={form.yabanciAd} onChange={function(e){guncelle('yabanciAd',e.target.value);}} className={INPUT} />
              </div>
              <div>
                <label className={LABEL}>Yabancı Soyad (KBS)</label>
                <input value={form.yabanciSoyad} onChange={function(e){guncelle('yabanciSoyad',e.target.value);}} className={INPUT} />
              </div>
              <div>
                <label className={LABEL}>Ana adı (KBS)</label>
                <input value={form.anaAdi} onChange={function(e){guncelle('anaAdi',e.target.value);}} className={INPUT} />
              </div>
              <div>
                <label className={LABEL}>Baba adı (KBS)</label>
                <input value={form.babaAdi} onChange={function(e){guncelle('babaAdi',e.target.value);}} className={INPUT} />
              </div>
            </div>

            {/* Sağ kolon */}
            <div className="space-y-4">
              <div>
                <label className={LABEL}>Şehir</label>
                <div className="relative">
                  <select value={form.sehir||''} onChange={function(e){guncelle('sehir',e.target.value); guncelle('ilce','');}}
                    className="w-full border border-gray-300 rounded px-3 py-2 pr-7 text-sm bg-white appearance-none focus:outline-none">
                    <option value="">Seçiniz</option>
                    {SEHIRLER.map(function(s){return <option key={s}>{s}</option>;})}
                  </select>
                  <span className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 text-xs">▼</span>
                </div>
              </div>
              <div>
                <label className={LABEL}>İlçe</label>
                <div className="relative">
                  <select value={form.ilce||''} onChange={function(e){guncelle('ilce',e.target.value);}}
                    className="w-full border border-gray-300 rounded px-3 py-2 pr-7 text-sm bg-white appearance-none focus:outline-none">
                    <option value="">Seçiniz</option>
                    {ilceler.map(function(i){return <option key={i}>{i}</option>;})}
                  </select>
                  <span className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 text-xs">▼</span>
                </div>
              </div>
              <div>
                <label className={LABEL}>Adres</label>
                <textarea value={form.adres} onChange={function(e){guncelle('adres',e.target.value);}}
                  rows={4} className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-200 resize-none" />
              </div>
            </div>
          </div>
        </div>

        {/* Alt butonlar */}
        <div className="flex items-center justify-between px-6 py-4 border-t border-gray-200">
          <button onClick={kaydet}
            className="bg-blue-600 hover:bg-blue-700 text-white px-10 py-2.5 rounded-lg text-sm font-bold transition-colors">
            Kaydet
          </button>
          <button onClick={async function(){if(await confirmAsync('Misafiri silmek istediğinize emin misiniz?')) onSil(misafir.id);}}
            className="bg-red-600 hover:bg-red-700 text-white px-6 py-2.5 rounded-lg text-sm font-bold transition-colors">
            SİL
          </button>
        </div>
      </div>
    </div>
  );

  function kaydet() {
    onKaydet(form);
    onClose();
  }
}

// ── Ana Sayfa ──
export default function SmsGonder() {
  var [giris, setGiris] = useState(birAyOnceStr());
  var [cikis, setCikis] = useState(gelecekHaftaStr());
  var [grupTip, setGrupTip] = useState('Farketmez');
  var [telefon, setTelefon] = useState('');
  var [boslarisGizle, setBoslariGizle] = useState(false);
  // Filtre tetikleyici — Filtrele butonuna basınca artarak state güncellenir
  var [filtreKey, setFiltreKey] = useState({ giris: birAyOnceStr(), cikis: gelecekHaftaStr(), grup:'Farketmez', tel:'', bosGizle:false });

  var [misafirler, setMisafirler] = useState(mockMisafirler);
  var [seciliIds, setSeciliIds] = useState([]);
  var [detayMisafir, setDetayMisafir] = useState(null);

  var [numaralar, setNumaralar] = useState('');
  var [smsMesaj, setSmsMesaj] = useState('');

  // Filtrele butonuna basınca snapshot al
  function filtrele() {
    setFiltreKey({ giris: giris, cikis: cikis, grup: grupTip, tel: telefon, bosGizle: boslarisGizle });
  }

  function temizle() {
    var bas = birAyOnceStr(); var bit = gelecekHaftaStr();
    setGiris(bas); setCikis(bit);
    setGrupTip('Farketmez'); setTelefon(''); setBoslariGizle(false);
    setFiltreKey({ giris: bas, cikis: bit, grup:'Farketmez', tel:'', bosGizle:false });
  }

  // Filtrelenmiş liste — filtreKey snapshot'ına göre hesaplanır
  var filtrelenmis = misafirler.filter(function(m) {
    var mGiris = ddmmyyyyToDate(m.girisTarihi);
    var fGiris = ddmmyyyyToDate(filtreKey.giris);
    var fCikis = ddmmyyyyToDate(filtreKey.cikis);
    // Saat sıfırla — sadece gün karşılaştırması
    if (fGiris) fGiris.setHours(0,0,0,0);
    if (fCikis) fCikis.setHours(23,59,59,999);
    if (mGiris) mGiris.setHours(0,0,0,0);
    if (fGiris && mGiris && mGiris < fGiris) return false;
    if (fCikis && mGiris && mGiris > fCikis) return false;
    if (filtreKey.grup !== 'Farketmez' && m.grup !== filtreKey.grup) return false;
    if (filtreKey.tel && !(m.telefon||'').includes(filtreKey.tel)) return false;
    if (filtreKey.bosGizle && !m.telefon) return false;
    return true;
  });

  // Checkbox
  function toggleSecim(id) {
    setSeciliIds(function(prev) {
      if (prev.includes(id)) return prev.filter(function(x){return x!==id;});
      return prev.concat(id);
    });
  }
  function toggleHepsi(checked) {
    if (checked) setSeciliIds(filtrelenmis.map(function(m){return m.id;}));
    else setSeciliIds([]);
  }

  // Seçili misafirlerin telefonlarını numara kutusuna ekle
  useEffect(function() {
    var telefonlar = seciliIds.map(function(id) {
      var m = misafirler.find(function(x){return x.id===id;});
      return m && m.telefon ? m.telefon : null;
    }).filter(Boolean);
    setNumaralar(telefonlar.join(', '));
  }, [seciliIds, misafirler]);

  function misafirGuncelle(form) {
    setMisafirler(function(prev) {
      return prev.map(function(m){ return m.id === form.id ? form : m; });
    });
  }
  function misafirSil(id) {
    setMisafirler(function(prev){ return prev.filter(function(m){return m.id!==id;}); });
    setDetayMisafir(null);
  }

  var hepsiSecili = filtrelenmis.length > 0 && filtrelenmis.every(function(m){return seciliIds.includes(m.id);});

  var SEL = "border border-gray-300 rounded px-3 py-1.5 text-sm bg-white focus:outline-none appearance-none pr-7 cursor-pointer";

  return (
    <div className="p-4 space-y-4">

      {/* Uyarı bandı */}
      <div className="bg-red-500 text-white px-4 py-3 rounded-lg text-sm font-medium">
        Sms paketiniz mevcut değildir.
      </div>

      <h1 className="text-base font-bold text-gray-700">SMS (Misafir) listesi</h1>

      {/* İki kolonlu layout */}
      <div className="flex gap-4 items-start">

        {/* Sol: Misafir listesi */}
        <div className="flex-1 min-w-0 bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">

          {/* Filtre çubuğu */}
          <div className="px-4 pt-4 pb-3 border-b border-gray-100">
            <div className="flex flex-wrap items-end gap-3">
              {/* Giriş Tarih */}
              <div>
                <label className="text-xs text-gray-500 font-medium block mb-1">Giriş Tarih</label>
                <DatePicker value={giris} onChange={function(v){
                  setGiris(v);
                  var b = v.split('.').reverse().join('-');
                  var e = cikis.split('.').reverse().join('-');
                  if(new Date(b)>new Date(e)) setCikis(v);
                }} maxDate={cikis} className="w-32" />
              </div>

              {/* Çıkış Tarih */}
              <div>
                <label className="text-xs text-gray-500 font-medium block mb-1">Çıkış Tarih</label>
                <DatePicker value={cikis} onChange={function(v){
                  var b = giris.split('.').reverse().join('-');
                  var e = v.split('.').reverse().join('-');
                  if(new Date(e) < new Date(b)) setCikis(giris);
                  else setCikis(v);
                }} minDate={giris} className="w-32" />
              </div>

              {/* Grup/Tip */}
              <div>
                <label className="text-xs text-gray-500 font-medium block mb-1">Grup/Tip</label>
                <div className="relative">
                  <select value={grupTip} onChange={function(e){setGrupTip(e.target.value);}} className={SEL + ' w-32'}>
                    {GRUP_TIP_LISTESI.map(function(g){return <option key={g}>{g}</option>;})}
                  </select>
                  <span className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 text-xs">▼</span>
                </div>
              </div>

              {/* Telefon */}
              <div>
                <label className="text-xs text-gray-500 font-medium block mb-1">Telefon</label>
                <input value={telefon} onChange={function(e){setTelefon(e.target.value);}}
                  placeholder="Telefon ara..."
                  className="border border-gray-300 rounded px-3 py-1.5 text-sm focus:outline-none w-36" />
              </div>

              {/* Boşları gizle */}
              <div className="flex items-center gap-2 pb-1">
                <input type="checkbox" id="bosGizle" checked={boslarisGizle}
                  onChange={function(e){setBoslariGizle(e.target.checked);}}
                  className="w-4 h-4 accent-blue-600 cursor-pointer" />
                <label htmlFor="bosGizle" className="text-xs text-gray-600 cursor-pointer">boşları gizle</label>
              </div>

              {/* Butonlar */}
              <div className="flex gap-2">
                <button onClick={filtrele}
                  className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-1.5 rounded text-sm font-bold transition-colors">
                  Filtrele
                </button>
                <button onClick={temizle}
                  className="bg-blue-400 hover:bg-blue-500 text-white px-4 py-1.5 rounded text-sm font-bold transition-colors">
                  Temizle
                </button>
              </div>
            </div>
          </div>

          {/* Tablo */}
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="bg-gray-50 border-b border-gray-200">
                  <th className="py-2.5 px-3 text-left">
                    <input type="checkbox" checked={hepsiSecili}
                      onChange={function(e){toggleHepsi(e.target.checked);}}
                      className="w-4 h-4 accent-blue-600 cursor-pointer" />
                  </th>
                  {['Ad soyad','Telefon','Cinsiyet','Grup','Kara liste','Ülke','Şehir','İlçe',''].map(function(h){
                    return <th key={h} className="py-2.5 px-3 text-left text-xs font-semibold text-gray-600 whitespace-nowrap">{h}</th>;
                  })}
                </tr>
              </thead>
              <tbody>
                {filtrelenmis.length === 0 ? (
                  <tr><td colSpan={9} className="text-center py-8 text-gray-400 text-sm">Kayıt bulunamadı</td></tr>
                ) : filtrelenmis.map(function(m){
                  var secili = seciliIds.includes(m.id);
                  return (
                    <tr key={m.id} className={'border-b border-gray-100 transition-colors ' + (secili ? 'bg-blue-50' : 'hover:bg-gray-50')}>
                      <td className="px-3 py-2">
                        <input type="checkbox" checked={secili}
                          onChange={function(){toggleSecim(m.id);}}
                          className="w-4 h-4 accent-blue-600 cursor-pointer" />
                      </td>
                      <td className="px-3 py-2 text-sm text-gray-800 font-medium">{m.adSoyad}</td>
                      <td className="px-3 py-2 text-sm text-gray-600">{m.telefon || <span className="text-gray-300">—</span>}</td>
                      <td className="px-3 py-2 text-sm text-gray-600">{m.cinsiyet}</td>
                      <td className="px-3 py-2 text-sm text-gray-600">{m.grup}</td>
                      <td className="px-3 py-2 text-sm text-gray-600">{m.karaListesi}</td>
                      <td className="px-3 py-2 text-sm text-gray-600">{m.ulke}</td>
                      <td className="px-3 py-2 text-sm text-gray-600">{m.sehir}</td>
                      <td className="px-3 py-2 text-sm text-gray-600">{m.ilce}</td>
                      <td className="px-3 py-2">
                        <button onClick={function(){setDetayMisafir(m);}}
                          className="bg-blue-600 hover:bg-blue-700 text-white text-xs px-3 py-1.5 rounded font-semibold whitespace-nowrap">
                          Detay
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>

        {/* Sağ: SMS gönderme paneli */}
        <div className="w-96 flex-shrink-0 bg-white rounded-xl border border-gray-200 shadow-sm p-4 space-y-4">

          {/* Numaralar */}
          <div>
            <label className="text-sm font-semibold text-gray-700 block mb-2">
              Numaralar <span className="text-xs text-gray-400 font-normal">(Aralarına virgül , koyunuz.)</span>
            </label>
            <textarea
              value={numaralar}
              onChange={function(e){setNumaralar(e.target.value);}}
              rows={6}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-200 resize-y"
              placeholder="05xx xxx xx xx, 05xx xxx xx xx"
            />
          </div>

          {/* SMS Mesaj */}
          <div>
            <div className="flex items-center justify-between mb-2">
              <label className="text-sm font-semibold text-gray-700">SMS Mesaj</label>
              <span className="text-xs text-gray-400">Karakter sayısı: {smsMesaj.length}</span>
            </div>
            <textarea
              value={smsMesaj}
              onChange={function(e){setSmsMesaj(e.target.value);}}
              rows={8}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-200 resize-y"
              placeholder="SMS mesajınızı buraya yazın..."
            />
          </div>

          {/* Gönder butonu */}
          <button
            onClick={function(){
              if (!numaralar.trim()) { alert('Lütfen en az bir numara girin.'); return; }
              if (!smsMesaj.trim()) { alert('Lütfen SMS mesajı girin.'); return; }
              alert('SMS gönderildi!\n\nNumaralar: ' + numaralar + '\n\nMesaj: ' + smsMesaj);
              setSmsMesaj('');
            }}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg text-sm font-bold transition-colors">
            Seçililere SMS gönder
          </button>
        </div>
      </div>

      {/* Misafir Detay Modal */}
      {detayMisafir && (
        <MisafirDetayModal
          misafir={detayMisafir}
          onClose={function(){setDetayMisafir(null);}}
          onKaydet={misafirGuncelle}
          onSil={misafirSil}
        />
      )}
    </div>
  );
}